import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '@/store';

export const selectProductsState = (state: RootState) => state.products;

export const selectAllProducts = createSelector([selectProductsState], (productsState) =>
  productsState.allIds.map((id) => productsState.byId[id])
);

export const selectProductById = (productId: string) =>
  createSelector([selectProductsState], (productsState) => productsState.byId[productId]);

export const selectFilteredProducts = createSelector(
  [selectAllProducts, selectProductsState],
  (products, productsState) => {
    const { search } = productsState.filters;

    return products.filter((product) => {
      if (search) {
        const searchLower = search.toLowerCase();
        const matchesSearch = product.name.toLowerCase().includes(searchLower);
        if (!matchesSearch) return false;
      }

      return true;
    });
  }
);

export const selectProductsLoading = createSelector(
  [selectProductsState],
  (productsState) => productsState.isLoading
);

export const selectProductsError = createSelector(
  [selectProductsState],
  (productsState) => productsState.error
);
